import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from '../../components/PageHero';
import { IconAward, IconTool, IconUsers, IconLeaf } from '../../components/Icons';
import './Nosotros.css';

const DIFF = [
  { Icon: IconAward, color: 'green', title: 'Experiencia comprobada', desc: 'Más de 10 años ejecutando proyectos mineros y ambientales en Colombia.' },
  { Icon: IconTool, color: 'blue', title: 'Rigor técnico', desc: 'Metodologías actualizadas conforme a normativa nacional e internacional vigente.' },
  { Icon: IconUsers, color: 'green', title: 'Acompañamiento integral', desc: 'Presentes desde la conceptualización hasta la ejecución y seguimiento.' },
  { Icon: IconLeaf, color: 'blue', title: 'Enfoque sostenible', desc: 'Responsabilidad ambiental integrada en cada solución técnica que diseñamos.' },
];

export default function QuienesSomos() {
  return (
    <div>
      <PageHero
        label="Nosotros"
        title="¿Quiénes Somos?"
        subtitle="Empresa colombiana de consultoría especializada en minería y medio ambiente, comprometida con la seguridad y la sostenibilidad."
        variant="green"
      />

      <section className="section">
        <div className="container">
          <div className="qs-grid">
            <div className="qs-text anim-fade-up">
              <div className="divider" />
              <h2 className="section-title">Sobre Impacta M.A. SAS</h2>
              <p>
                <strong>Impacta M.A. SAS</strong> es una empresa colombiana de consultoría especializada en minería y medio ambiente, con base en el departamento de Boyacá. Nació de la necesidad del sector minero de contar con soporte técnico especializado y responsable que garantice la seguridad de los trabajadores y el cumplimiento de la normatividad vigente.
              </p>
              <p>
                Contamos con un equipo multidisciplinario de ingenieros con amplia experiencia en operaciones mineras subterráneas, gestión ambiental y trámites ante autoridades como la <strong>Agencia Nacional Minera (ANM)</strong>, el <strong>ANLA</strong> y las corporaciones autónomas regionales.
              </p>
              <p>
                Nuestra razón de ser es acompañar a los mineros y empresas del sector en el cumplimiento técnico y normativo, promoviendo siempre una minería segura, legal y ambientalmente responsable.
              </p>
              <div className="qs-actions">
                <Link to="/nosotros/mision-vision" className="btn btn--primary">Misión y Visión</Link>
                <Link to="/nosotros/valores" className="btn btn--outline">Valores Corporativos</Link>
              </div>
            </div>
            <div className="qs-card anim-fade-up anim-delay-2">
              <div className="qs-card__logo-wrap">
                <picture>
                  <source srcSet="/logo3.webp" type="image/webp" />
                  <img src="/logo3.webp" alt="Impacta M.A. SAS" />
                </picture>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--bg">
        <div className="container">
          <div className="divider divider--center" />
          <h2 className="section-title section-title--center">Lo que nos diferencia</h2>
          <div className="qs-diff-grid">
            {DIFF.map(({ Icon, color, title, desc }) => (
              <div className="qs-diff-card card card--elevated" key={title}>
                <div className={`qs-diff-icon qs-diff-icon--${color}`}>
                  <Icon size={30} />
                </div>
                <h3>{title}</h3>
                <p>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
